import { useTranslation } from 'react-i18next'
import React, { useEffect } from 'react'

import AddNewButton from '../AddNewButton'
import FilterWrapper from '../filters/FilterWrapper'
import FullPageTemplate from '../../../../components/templates/FullPageTemplate'
import MMainMenu from '../../../menu/mainMenu/M.MainMenu'
import MPageHeader from '../../../../components/presentation/M.PageHeader'
import PageContent from './PageContent'
import PageHeader from './PageHeader'
import Separator from '../../../../components/helpers/Separator'
import ServiceOrderNotificationAlert from '../../_common/ServiceOrderNotificationAlert'

const MServiceOrdersListPage = () => {
  const { t } = useTranslation('settings')

  return (
    <FullPageTemplate>
      <ServiceOrderNotificationAlert>
        <MPageHeader title={t('listServiceOrders:title')} />
        <FilterWrapper>
          <PageHeader />
          <PageContent />
        </FilterWrapper>
        <Separator />
        <MMainMenu active="serviceOrders" />
        <AddNewButton />
      </ServiceOrderNotificationAlert>
    </FullPageTemplate>
  )
}

export default MServiceOrdersListPage
